import { useState } from "react";
import { ShieldCheck, LockKey, UsersThree, ListChecks, CaretDown } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

const POINTS = [
  {
    icon: UsersThree,
    title: "Isolated to your organization",
    body: "Your workspace is strictly separated. Your documents, deliverables and posture data are never visible to any other client.",
  },
  {
    icon: ListChecks,
    title: "Every access is audited",
    body: "Activity in this portal is recorded on a tamper-evident audit trail that your DAAKYI team can verify at any time.",
  },
  {
    icon: ShieldCheck,
    title: "Human-reviewed AI",
    body: "Anything drafted with Tukoro AI is reviewed and approved by your DAAKYI consultants before it ever reaches you.",
  },
];

/** Quiet trust strip at the bottom of the client portal — security is the product. */
export function PortalTrustFooter() {
  const [open, setOpen] = useState(false);
  return (
    <footer className="mx-auto w-full max-w-6xl px-6 pb-8 sm:px-8" data-testid="portal-trust-footer">
      <div className="border-t border-border pt-5">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          data-testid="portal-trust-toggle"
          className="group flex w-full items-center justify-center gap-2 text-center"
        >
          <LockKey className="h-3.5 w-3.5 shrink-0 text-success" weight="fill" />
          <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground transition-colors group-hover:text-foreground">
            Your data is isolated to your organization, encrypted in transit, and every access is audited
          </span>
          <CaretDown className={cn("h-3 w-3 shrink-0 text-muted-foreground/60 transition-transform", open && "rotate-180")} weight="bold" />
        </button>

        {open && (
          <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3" data-testid="portal-trust-details">
            {POINTS.map((p) => (
              <div key={p.title} className="border border-border bg-card p-4">
                <p className="flex items-center gap-2 text-xs font-semibold text-foreground">
                  <p.icon className="h-4 w-4 shrink-0 text-success" weight="duotone" /> {p.title}
                </p>
                <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground">{p.body}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </footer>
  );
}
